import React from 'react';
import Carousel from 'react-material-ui-carousel'
import Item from './Item';
import banner1 from '../../assets/Carousel/banner1.svg';



function ImageSlider() {
    const images = [
        {
            id: 1,
            imgPath: banner1,
        },
        {
            id: 2,
            imgPath: banner1,
        },
        {
            id: 3,
            imgPath: banner1,
        },
        {
            id: 4,
            imgPath: banner1,
        },
    ];



    return (
        <Carousel className='homePageSlider ' animation='slide' navButtonsAlwaysInvisible={true} height={300} indicatorIconButtonProps={{
    style: {
        color: '#ccc',
    }
}}

activeIndicatorIconButtonProps={{
    style: {
        color: '#FEC513',
    }
}}>
            {
                images.map((image, i) => <Item key={image.id} item={image} />)
            }
        </Carousel>
    )
}

export default ImageSlider